
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M28.357 25.452a2.111 2.111 0 000-2.978l-4.106-4.1a2.12 2.12 0 00-2.983 0l-1.568 1.56-.149.149a2.12 2.12 0 01-2.983 0l-6.708-6.7a2.111 2.111 0 010-2.978l.149-.149L11.577 8.7a2.111 2.111 0 000-2.978L7.466 1.613a2.12 2.12 0 00-2.983 0l-.771.779C-1.329 7.425.892 13.79 8.434 21.314l.2.192c7.537 7.524 13.913 9.747 18.954 4.715l.766-.77","fill":"#222"}})])
          )
        }
      }
    